import { FilterSchema } from '../../../molecules/FilterBuilder/types';

export const settlementFilterSchema: FilterSchema[] = [
    // ─── Campos Principais (visíveis) ─────────────────────────────────────────
    { key: 'contract_number', label: 'Nº Contrato', type: 'text', operators: ['eq', 'contains'], defaultOperator: 'contains', visible: true },
    { key: 'status', label: 'Status', type: 'enum', operators: ['in', 'not_in'], defaultOperator: 'in', visible: true, options: [
        { value: 'OPEN', label: 'Em aberto' },
        { value: 'PAID', label: 'Pago' },
        { value: 'PARTIALLY_PAID', label: 'Parcial' },
        { value: 'SUPERSEDED', label: 'Renegociado' },
        { value: 'CANCELLED', label: 'Cancelado' },
        { value: 'PAID_WITH_LOSS', label: 'Pago c/ perda' },
    ]},
    { key: 'due_date', label: 'Vencimento', type: 'date', operators: ['before', 'after', 'between_dates'], defaultOperator: 'between_dates', visible: true },
    { key: 'contract_modality', label: 'Modalidade', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: true, options: [
        { value: 'LOAN', label: 'Empréstimo (LOAN)' },
        { value: 'CESSION', label: 'Cessão (CESSION)' },
    ]},

    // ─── Campos Ocultos (aparecem via "+ Filtro") ─────────────────────────────
    { key: 'amount', label: 'Valor', type: 'number', operators: ['eq', 'gt', 'lt', 'gte', 'lte', 'between'], defaultOperator: 'between', visible: false },
    { key: 'paid_amount', label: 'Valor Pago', type: 'number', operators: ['eq', 'gt', 'lt', 'gte', 'lte'], defaultOperator: 'gt', visible: false },
    { key: 'payer_name', label: 'Pagador', type: 'text', operators: ['contains', 'eq'], defaultOperator: 'contains', visible: false },
    { key: 'negotiation_type', label: 'Tipo Negociação', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'ORIGINAL', label: 'Original' },
        { value: 'RENEGOTIATION', label: 'Renegociação' },
        { value: 'AGREEMENT', label: 'Acordo' },
        { value: 'DEBT_CONFESSION', label: 'Confissão de Dívida' },
        { value: 'COLLATERAL', label: 'Garantia' },
    ]},
    { key: 'payment_type', label: 'Tipo Pagamento', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'FINANCIAL', label: 'Financeiro' },
        { value: 'DEBT_CONFESSION', label: 'Confissão de Dívida' },
        { value: 'ASSET_DATION', label: 'Dação de Bens' },
    ]},
    { key: 'payment_method', label: 'Meio Pagamento', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'PIX', label: 'PIX' },
        { value: 'TED', label: 'TED' },
        { value: 'BOLETO', label: 'Boleto' },
    ]},
    { key: 'pending_guarantor_refund', label: 'Aval a Devolver', type: 'boolean', operators: ['is_true', 'is_false'], defaultOperator: 'is_true', visible: false },
    { key: 'installment_number', label: 'Nº Parcela', type: 'number', operators: ['eq', 'gt', 'lt'], defaultOperator: 'eq', visible: false },
    { key: 'amendment_number', label: 'Nº Aditamento', type: 'number', operators: ['eq', 'gt'], defaultOperator: 'eq', visible: false },
    { key: 'business_reference', label: 'Referência', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'INSTALLMENT', label: 'Parcela' },
        { value: 'RECEIVABLE', label: 'Recebível' },
    ]},

    // ─── Lookup (busca avançada em contratos) ─────────────────────────────────
    { key: 'credit_operation_id', label: 'Contrato (avançado)', type: 'lookup', operators: ['in_lookup'], defaultOperator: 'in_lookup', visible: false, lookupConfig: {
        endpoint: '/contracts/page-list',
        searchField: 'search',
        displayField: 'operation_number',
        valueField: 'credit_operation_id',
    }},
];

/**
 * Serializa filtros aplicados para query params da API settlement.
 * Formato: filter[field][operator]=value
 */
export const serializeFilters = (filters: any[]): URLSearchParams => {
    const params = new URLSearchParams();

    for (const f of filters) {
        if (f.type === 'boolean') {
            if (f.operator === 'is_true') params.set(`filter[${f.key}]`, 'true');
            else if (f.operator === 'is_false') params.set(`filter[${f.key}]`, 'false');
            continue;
        }

        if (!f.value || (Array.isArray(f.value) && f.value.every((v: any) => !v))) continue;

        switch (f.operator) {
            case 'eq':
            case 'contains':
            case 'starts_with':
            case 'ends_with':
                params.set(`filter[${f.key}][${f.operator}]`, f.value);
                break;
            case 'gt': case 'lt': case 'gte': case 'lte':
            case 'before': case 'after':
                params.set(`filter[${f.key}][${f.operator}]`, f.value);
                break;
            case 'between':
            case 'between_dates':
                if (f.value[0]) params.set(`filter[${f.key}][gte]`, f.value[0]);
                if (f.value[1]) params.set(`filter[${f.key}][lte]`, f.value[1]);
                break;
            case 'in':
            case 'in_lookup':
                const vals = Array.isArray(f.value) ? f.value.join(',') : f.value;
                if (vals) params.set(`filter[${f.key}]`, vals);
                break;
            case 'not_in':
                const nvals = Array.isArray(f.value) ? f.value.join(',') : f.value;
                if (nvals) params.set(`filter[${f.key}][not_in]`, nvals);
                break;
        }
    }

    return params;
};
